var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"pool-action-btn",class:{
    active: _vm.checkedCount > 0,
    'is-disabled': !_vm.checkedCount,
  },on:{"click":_vm.batchAssign}},[_c('i',{staticClass:"el-icon-folder-checked"}),_vm._v(" "+_vm._s(_vm.$l('btn_batch_assign') || '批量分配')+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }